import api from './api';

export default {
  getSteps() {
    return api.get('/scount-steps/api/v1/steps');
  },
  setTargetSteps({ targetCount }) {
    return api.post('/scount-steps/api/v1/targets', {
      targetCount,
    });
  },
  getStepsHistory({ dateFrom, dateTo, periodType }) {
    return api.get('/scount-steps/api/v1/participants/steps-with-targets', {
      params: {
        dateFrom,
        dateTo,
        periodType,
      },
    });
  },
  getParticipantPosition({ dateFrom, dateTo, periodType }) {
    return api.get('/scount-steps/api/v1/ratings/participant-position', {
      params: {
        dateFrom,
        dateTo,
        periodType,
      },
    });
  },
  getPeriodSteps({ dateFrom, dateTo, periodType }) {
    return api.get('/scount-steps/api/v1/ratings/periods', {
      params: {
        dateFrom,
        dateTo,
        periodType,
      },
    });
  },
  getParticipantAndNeighbors({ dateFrom, dateTo, periodType }) {
    return api.get('/scount-steps/api/v1/ratings/participant-and-neighbors', {
      params: {
        dateFrom,
        dateTo,
        periodType,
      },
    });
  },
  getRatings({
    dateFrom, dateTo, periodType, offset, count,
  }) {
    return api.get('/scount-steps/api/v1/ratings', {
      params: {
        dateFrom,
        dateTo,
        periodType,
        offset,
        count,
      },
    });
  },
};
